import {
  Text,
  AuthUI,
  Button,
  Link,
  GreyGrey100,
  GreyGrey70,
  GreyGrey80,
  IndigoIndigo60,
  Primary14ExtendedRegular,
  PrimaryHeader32Regular
} from '@sequencehq/core-components'
import { useSearchParams } from 'react-router-dom'

import { getDashboardDomain } from 'modules/LoginApp/helpers'
import { isProductionEnv } from 'lib/environment/environment'

const PROVIDER_NAMES: Partial<Record<string, string>> = {
  google: 'Google',
  microsoft: 'Microsoft'
}

export const NoWorkspacePage = () => {
  const [searchParams] = useSearchParams()
  const providerName = PROVIDER_NAMES[searchParams.get('provider') ?? '']

  const targetEnvironment = isProductionEnv() ? 'sandbox' : 'production'
  const targetUrl = `https://${getDashboardDomain(
    targetEnvironment
  )}/auth/login`

  return (
    <AuthUI.Section gap="24px">
      <AuthUI.Section gap="8px">
        <Text
          {...PrimaryHeader32Regular}
          textAlign="left"
          color={GreyGrey100}
          marginBottom="0px"
        >
          You're not part of a workspace
        </Text>
        <Text
          {...Primary14ExtendedRegular}
          color={GreyGrey80}
          data-testid="loginApp.noWorkspace.description"
        >
          {providerName
            ? `The ${providerName} account you signed in with is not a member of any workspace in this environment. ${providerName} sign-in only opens workspaces you already belong to or have been invited to. Please ask your administrator for an invite or try a different account.`
            : 'The email address you provided is not currently associated with any workspace in this environment. Please contact your administrator or try signing in with a different email.'}
        </Text>
      </AuthUI.Section>
      <AuthUI.Section gap="8px">
        <Link
          to="/login"
          _hover={{
            textDecoration: 'none'
          }}
        >
          <Button
            variant="primary"
            fullWidth
            size="40px"
            style={{ fontSize: '14px', borderRadius: '8px' }}
          >
            Try again
          </Button>
        </Link>
        <Link
          to={targetUrl}
          _hover={{
            textDecoration: 'none'
          }}
        >
          <Button
            variant="secondary"
            fullWidth
            size="40px"
            style={{ fontSize: '14px', borderRadius: '8px' }}
          >
            Try again in {targetEnvironment}
          </Button>
        </Link>
      </AuthUI.Section>
      {/* Helper Text */}
      <Text
        fontSize="14px"
        color={GreyGrey70}
        textAlign="left"
        lineHeight="1.4"
        width="100%"
      >
        New to Sequence?{' '}
        <Link
          color={IndigoIndigo60}
          to="https://www.sequencehq.com/book-a-demo"
        >
          Book a demo
        </Link>
      </Text>
    </AuthUI.Section>
  )
}

export default NoWorkspacePage
